/**
 * This function is used to wrap all the colors/tokens during automated token migration
 * The purpose is to be able to switch AI-applied tokens back to the original colors.
 * @param _color - original color
 * @param token - AI-applied token
 */
export const colorOrToken = (_color: any, token: string) => {
  return token;
};
